import moment from "moment"

const monthArray = [
    { value: 'Jan', name: 'January', id: 0 },
    { value: 'Feb', name: 'February', id: 1 },
    { value: 'Mar', name: 'March', id: 2 },
    { value: 'Apr', name: 'April', id: 3 },
    { value: 'May', name: 'May', id: 4 },
    { value: 'Jun', name: 'Jun', id: 5 },
    { value: 'Jul', name: 'July', id: 6 },
    { value: 'Aug', name: 'Auguest', id: 7 },
    { value: 'Sep', name: 'September', id: 8 },
    { value: 'Oct', name: 'October', id: 9 },
    { value: 'Nov', name: 'November', id: 10 },
    { value: 'Dec', name: 'December', id: 11 }
]

const dateFormat = [
    { id: 'mm/dd/yyyy', name: 'MM/DD/YYYY' },
    { id: 'dd/mm/yyyy', name: 'DD/MM/YYYY' },
    { id: 'dd-mmm-yyyy', name: 'DD-MMM-YYYY' },
]
const currencyFormat = [
    { id: 's', name: "10 000,00" },
    { id: '.', name: '10.000,00' },
    { id: ',', name: '10,000.00' }
]

const monthfind = (id) => {
    let value = 0
    let ext = monthArray.find(itm => itm.id === id)
    if (ext) value = ext.value
    return value
}

const monthname = (id) => {
    if (id) id = Number(id) - 1
    let ext = monthArray.find(itm => itm.id === id)
    return ext ? ext?.name : '--'
}

const getWeekDate = (date = new Date(), week = 1) => {
    let d = new Date(date)
    let month = d.getMonth()
    month = String(month + 1)

    let value = 1
    if (week == 1) value = 1
    else if (week > 1) value = 7 * (week - 1)
    if (value > 30) value = 30

    return new Date(`${d.getFullYear()}-${month}-${value}`)
}
const date = (p, companyDateFormat = '', iso = false) => {
    try {
        let format = companyDateFormat;
        if (!p) return '--';
        
        let year, month, day;
        
        // Handle Date objects
        if (p instanceof Date) {
            year = p.getFullYear();
            month = p.getMonth() + 1;
            day = p.getDate();
        }
        // Handle string inputs
        else if (typeof p === 'string') {
            let pv = p;
            if (iso) pv = p.split('T')[0];
            
            // Try different date string formats
            if (pv.includes('-')) {
                // YYYY-MM-DD or MM-DD-YYYY format
                const dateParts = pv.split('-');
                if (dateParts[0].length === 4) {
                    // YYYY-MM-DD format
                    year = parseInt(dateParts[0]);
                    month = parseInt(dateParts[1]);
                    day = parseInt(dateParts[2]?.split(' ')[0] || dateParts[2]);
                } else {
                    // MM-DD-YYYY format
                    year = parseInt(dateParts[2]);
                    month = parseInt(dateParts[0]);
                    day = parseInt(dateParts[1]);
                }
            }
            else if (pv.includes('/')) {
                // MM/DD/YYYY or DD/MM/YYYY format
                const dateParts = pv.split('/');
                if (dateParts[0].length === 4) {
                    // YYYY/MM/DD format
                    year = parseInt(dateParts[0]);
                    month = parseInt(dateParts[1]);
                    day = parseInt(dateParts[2]?.split(' ')[0] || dateParts[2]);
                } else if (dateParts[2].length === 4) {
                    // MM/DD/YYYY or DD/MM/YYYY - need to check which one
                    if (parseInt(dateParts[0]) > 12) {
                        // DD/MM/YYYY (first part is day > 12)
                        year = parseInt(dateParts[2]);
                        month = parseInt(dateParts[1]);
                        day = parseInt(dateParts[0]);
                    } else {
                        // MM/DD/YYYY (first part is month <= 12)
                        year = parseInt(dateParts[2]);
                        month = parseInt(dateParts[0]);
                        day = parseInt(dateParts[1]);
                    }
                }
            }
            else {
                // Fallback: try to parse as Date object
                const fallbackDate = new Date(pv);
                if (!isNaN(fallbackDate.getTime())) {
                    year = fallbackDate.getFullYear();
                    month = fallbackDate.getMonth() + 1;
                    day = fallbackDate.getDate();
                } else {
                    return '--';
                }
            }
        }
        // Handle numbers (timestamps)
        else if (typeof p === 'number') {
            const dateObj = new Date(p);
            year = dateObj.getFullYear();
            month = dateObj.getMonth() + 1;
            day = dateObj.getDate();
        }
        else {
            return '--';
        }
        
        // Validate parsed values
        if (isNaN(year) || isNaN(month) || isNaN(day) || month < 1 || month > 12 || day < 1 || day > 31) {
            return '--';
        }
        
        let value = `${day}-${monthfind(month - 1)}-${year}`;
        
        if (format === 'mm/dd/yyyy') {
            value = `${String(month).padStart(2, '0')}/${String(day).padStart(2, '0')}/${year}`;
        } else if (format === 'dd/mm/yyyy') {
            value = `${String(day).padStart(2, '0')}/${String(month).padStart(2, '0')}/${year}`;
        } else if (format === 'yyyy-mm-dd') {
            value = `${year}-${String(month).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
        }
        
        return value;
    } catch {
        return null;
    }
}

const stringToDate = (p) => {
    let d = ''
    if (p) {
        d = new Date(p)
    }
    return d
}

const daysArray = [
    { value: 'monday', id: 1 },
    { value: 'tuesday', id: 2 },
    { value: 'wednesday', id: 3 },
    { value: 'thursday', id: 4 },
    { value: 'friday', id: 5 },
    { value: 'saturday', id: 6 },
    { value: 'sunday', id: 0 },
]

const getDayName = (id) => {
    let value = daysArray.find((itm) => itm.id === id).value
    return value;
}

const day = (p) => {
    if (!p) return ''
    let day = new Date(p).getDay()
    day = getDayName(day)?.toLowerCase()
    return day
}

const time = (p, tz = '', type = false) => {
    let timeZone = tz
    let value = ''
    // if(type){
    //     return moment(new Date(p)).format('hh:mm a')
    // }
    try {
        if (!p) return ''
        if (type) {
            let timeString = p.split('T')[1] || p.split(' ')[1]
            let data = moment.utc(timeString, 'HH:mm:ss.SSSZ').format('h:mm A');
            if (data?.toLowerCase().includes('invalid') || timeString?.toLowerCase().includes('+')) {
                if (timeString) {
                    return timeString?.split('+')[0]
                } else {
                    return null
                }
            } else {
                if (data) {
                    return data
                } else {
                    return timeString.split('+')[0]
                }
            }
        }
        let v = p?.split('-')
        if (v.length > 2) {
            value = new Date(p).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            if (timeZone) {
                value = new Date(p).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: timeZone })
            }
        } else {
            value = new Date(`2020-07-19 ${p}`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true })
            if (timeZone) {
                value = new Date(`2020-07-19 ${p}`).toLocaleString('en-US', { hour: 'numeric', minute: 'numeric', hour12: true, timeZone: timeZone })
            }
        }
        if (value.includes('invalid')) {
            return ""
        } else {
            return value
        }
    } catch {
        return null
    }
}

const datetime = (p, format = '', timeZone = '') => {
    return `${date(p, format, false, timeZone)}, ${time(p, timeZone,true)}`
}

const timeString = (p) => {
    let date = new Date(p)
    let hr = String(date.getHours())
    let minutes = String(date.getMinutes())
    if (hr.length === 1) hr = `0${hr}`
    if (minutes.length === 1) minutes = `0${minutes}`
    return `${hr}:${minutes}:00`
}
const datetostring = (p) => {
    if (!p) return '';
    
    try {
        // Handle Date objects
        if (p instanceof Date) {
            if (isNaN(p.getTime())) return ''; // Invalid Date
            const year = p.getFullYear();
            const month = String(p.getMonth() + 1).padStart(2, '0');
            const day = String(p.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        
        // Handle string inputs
        if (typeof p === 'string') {
            const dateStr = p.trim();
            
            // Handle YYYY-MM-DD format (with or without time)
            if (dateStr.match(/^\d{4}-\d{2}-\d{2}/)) {
                return dateStr.split(' ')[0]; // Return only date part
            }
            
            // Handle MM/DD/YYYY or DD/MM/YYYY format
            if (dateStr.includes('/')) {
                const parts = dateStr.split('/');
                if (parts.length === 3) {
                    // Determine format: if first part > 12, it's probably DD/MM/YYYY
                    if (parseInt(parts[0]) > 12) {
                        // DD/MM/YYYY format
                        return `${parts[2]}-${parts[1].padStart(2, '0')}-${parts[0].padStart(2, '0')}`;
                    } else {
                        // MM/DD/YYYY format
                        return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                    }
                }
            }
            
            // Handle MM-DD-YYYY format
            if (dateStr.includes('-') && dateStr.match(/^\d{1,2}-\d{1,2}-\d{4}/)) {
                const parts = dateStr.split('-');
                if (parts.length === 3) {
                    return `${parts[2]}-${parts[0].padStart(2, '0')}-${parts[1].padStart(2, '0')}`;
                }
            }
            
            // Handle timestamp (number as string)
            if (!isNaN(Number(dateStr))) {
                const date = new Date(Number(dateStr));
                if (!isNaN(date.getTime())) {
                    const year = date.getFullYear();
                    const month = String(date.getMonth() + 1).padStart(2, '0');
                    const day = String(date.getDate()).padStart(2, '0');
                    return `${year}-${month}-${day}`;
                }
            }
        }
        
        // Handle number inputs (timestamps)
        if (typeof p === 'number') {
            const date = new Date(p);
            if (!isNaN(date.getTime())) {
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const day = String(date.getDate()).padStart(2, '0');
                return `${year}-${month}-${day}`;
            }
        }
        
        // Fallback: try to parse as Date object
        const fallbackDate = new Date(p);
        if (!isNaN(fallbackDate.getTime())) {
            const year = fallbackDate.getFullYear();
            const month = String(fallbackDate.getMonth() + 1).padStart(2, '0');
            const day = String(fallbackDate.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        }
        
        return '';
        
    } catch {
        return '';
    }
}

const getprepostdays = (p, no, type = 'pre') => {
    if (!p) return []
    let date = new Date(p)
    let arr = []
    if (type == 'pre') {
        for (let i = 1; i <= no; i++) {
            date.setDate(date.getDate() - 1)
            arr.push(datetostring(date))
        }
    } else if (type == 'post') {
        for (let i = 1; i <= no; i++) {
            date.setDate(date.getDate() + 1)
            arr.push(datetostring(date))
        }
    }

    return arr
}

const datetoIso = (p) => {
    if (!p) return ''
    let date = datetostring(p)

    let value = `${date}T09:00:00.000Z`
    return value
}

const datetoIsotime = (p) => {
    let date = datetostring(p)
    let time = timeString(p)
    let value = `${date}T${time}.000Z`
    return value
}

const isototime = (p) => {
    if (!p) return ''
    let value = p?.split('T')[1]?.split('.000Z')
    if (value.length === 2) {
    } else {
        value = p?.split('T')[1]?.split('+')
    }
    return value[0]
}

const isotime = (p) => {
    return time(isototime(p))
}

const isotodate = (p) => {
    let d = new Date(`${datetostring(p)} ${isototime(p)}`)
    return d
}

const DaysNo = (s, e) => {
    // JavaScript program to illustrate 
    // calculation of no. of days between two date 

    // To set two dates to two variables
    let date1 = new Date(s);
    let date2 = new Date(e);

    // To calculate the time difference of two dates
    let Difference_In_Time = date2.getTime() - date1.getTime();

    // To calculate the no. of days between two dates
    let Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);

    return Difference_In_Days + 1
}


const getDays = (strDate, endDate) => {
    let date1 = new Date(strDate);
    let date2 = new Date(endDate);
    let value = 0
    let diff = Math.abs(date2.getTime() - date1.getTime());
    let noofdays = Math.ceil(diff / (1000 * 3600 * 24));
    if (date1 > date2) {
    }
    else {
        value = noofdays
    }
    value = value == 0 ? 1 : value;
    return value
}

const getDateStringArray = (strDate, endDate) => {
    let dArray = [];
    let sDate;
    let eDate;

    let prm = []
    let ps = String(strDate)
    prm = ps?.split('-');

    if (prm.length == 3) {
        sDate = stringToDate(strDate);
        eDate = stringToDate(endDate);
    } else {
        sDate = new Date(strDate)
        eDate = new Date(endDate)
    }

    let total = getDays(strDate, endDate)

    if (sDate.getTime() == eDate.getTime()) {
        dArray.push(datetostring(sDate));
    } else {
        for (let i = 0; i <= total; i++) {
            // Adding the date to array
            // Increment the date by 1 day
            dArray.push(datetostring(sDate));
            sDate.setDate(sDate.getDate() + 1);
        }
    }

    return dArray;
}

function secondsToHoursMinutes(s) {
    let seconds = s || 0
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    let value = `${hours}h ${minutes}m`
    if (seconds < 60) {
        value = `${seconds.toFixed(2)}s`
    } else if (minutes < 60) {
        value = `${minutes}m`
    }
    return value;
}

function secondsToMinutesSeconds(seconds) {
    if (isNaN(seconds)) return "0s";
    seconds = Math.floor(Math.max(0, seconds));

    const units = [];
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;

    if (hours > 0) units.push(`${hours}h`);
    if (minutes > 0) units.push(`${minutes}m`);
    if (secs > 0 || (hours === 0 && minutes === 0)) units.push(`${secs}s`);

    return units.join(" ");
}

function getDateTimeInTimeZone(timeZone) {
    try{
    const now = new Date(); // Current date and time from user PC

    const options = {
        timeZone: timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false
    };

    // Format the date to string in the target timezone
    const formatter = new Intl.DateTimeFormat("en-GB", options);
    const parts = formatter.formatToParts(now);

    // Construct a clean string like "YYYY-MM-DD HH:MM:SS"
    const dateTimeString = `${parts.find(p => p.type === 'year').value}-${parts.find(p => p.type === 'month').value}-${parts.find(p => p.type === 'day').value} ${parts.find(p => p.type === 'hour').value}:${parts.find(p => p.type === 'minute').value}:${parts.find(p => p.type === 'second').value}`;

    return dateTimeString;
}catch{
    return new Date().toISOString()
}
}

const datepipeModel = {
    monthArray,
    getDateTimeInTimeZone,
    secondsToHoursMinutes,
    secondsToMinutesSeconds,
    monthname,
    DaysNo,
    getDateStringArray,
    date,
    stringToDate,
    day,
    datetostring,
    datetoIso,
    isototime,
    isotodate,
    isotime,
    datetoIsotime,
    time,
    timeString,
    datetime,
    monthfind,
    getprepostdays,
    getWeekDate,
    dateFormat,
    currencyFormat
}

export default datepipeModel;
